import accounting from 'accounting';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React from 'react';
import { SvgInfoIcon } from '../components/svg';
import { exportAnsweredQuestions } from '../api/health-questions/actions';
import TilbodStepCollectInfo from '../components/tilbod-step-collect-info';
import TilbodStepFinal from '../components/tilbod-step-final';
import TilbodStepHealthQuestions from '../components/tilbod-step-health-questions';
import TilbodStepId from '../components/tilbod-step-id';
import TilbodStepNoSigning from '../components/tilbod-step-no-signing';
import TilbodStepOne from '../components/tilbod-step-one';
import TilbodStepPayment from '../components/tilbod-step-payment';
import TilbodStepShowQuote from '../components/tilbod-step-show-quote';
import TilbodStepSignature from '../components/tilbod-step-signature';
import {
    CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING,
    CONTRACTS_VISIBLE_MAPPING,
    CONTRACT_STATUS_ACTIVE,
    CONTRACT_STATUS_WAITING,
    offerTypesForBeneficiaries,
    STEP_COLLECT_INFO,
    STEP_FINAL, STEP_HEALTH_QUESTIONS,
    STEP_ID,
    STEP_NO_SIGNATURE,
    STEP_PAYMENT,
    STEP_SHOW_QUOTE,
    STEP_SIGNATURE,
    STEP_START
} from '../constants';
import { store } from '../store';
const kennitala = require('kennitala')

export function parseJSON(response) {
    return response.json();
}

export const handleNetworkError = (error) => {
    if (window.Raven !== undefined) {
        Raven.captureException(error)
    } else {
        throw (error)
    }
}

export const triggerSentryError = (message) => {
    if (window.Sentry !== undefined) {
        Sentry.captureMessage(message)
    }
}

export const Spinner = (props) => <i className="spinner fa fa-spinner fa-pulse"></i>;



export const formatKennitala = (value) => {
    if (value.length < 10) {
        return value
    }
    return `${value.substring(0, 6)}-${value.substring(6, 10)}`
}

export const formatKennitalaAsDate = (value) => {
    var kt = kennitala.info(value)
    if (kt.valid) {
        return moment.utc(kt.birthday).format("DD/MM/YYYY")
    }
    return value
}

export const getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}


export const formatMoney = (num, decimals = 0) => {
    return accounting.formatMoney(+num, '', decimals, ".", ",")
}

export const formatNumber = (num, decimals = 0) => {
    return accounting.formatNumber(num, decimals, ".", ",")
}


export const getUrlParam = (parameter, defaultvalue) => {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

export const processTimeSeries = (timeseries) => {
    let grouped = timeseries.reduce((r, a) => {
        a["Termin"] = moment.utc(a["Termin"])
        let x = {
            x: a["Termin"].toDate(),
            y: parseFloat(a["Betrag"]),
            k: a["Art"],
        }
        r[a["Art"]] = [...r[a["Art"]] || [], x];
        return r;
    }, {});
    return grouped

}

export const mergeTimeSeriesForTables = (timeseries) => {

    let grouped = timeseries.reduce((r, a) => {

        let key = moment.utc(a["Termin"]).format('YYYY')

        if (a["Art"].includes("Rückkauf")) {
            key = moment.utc(a["Termin"]).add(1, 'day').format('YYYY')
        }

        if (r[key] !== undefined) {
            r[key][a["Art"]] = parseFloat(a["Betrag"])
        } else {
            r[key] = {
                [a["Art"]]: parseFloat(a["Betrag"]),
                dateObject: moment.utc(a["Termin"])
            }
        }
        return r;

    }, {})

    return grouped

}

export const customerNameById = (customerId, customers) => {
    return customers.peopleByKennitala[customerId]
}

export const customerByKennitala = (customerId, customers) => {
    let result = customers.customerList.filter((item => item.Customer.AccountNum === customerId))
    if (result.length > 0) {
        return result[0]
    }
    return null
}

export const getPaymentKeyText = (value) => {
    let paymentTextKey = "ris.monthly_payment"
    switch (value) {
        case "monthly":
            paymentTextKey = "ris.monthly_payment"
            break;
        case "quarterly":
            paymentTextKey = "ris.quarterly_payment"
            break;
        case "every6months":
            paymentTextKey = "ris.biannual_payment"
            break;
        case "yearly":
            paymentTextKey = "ris.annual_payment"
            break;
        default:
            paymentTextKey = "ris.monthly_payment"
            break;
    }
    return paymentTextKey
}


export const summarizeOfferCheckboxes = (offerQueryParameters, partnerSeparate = false) => {
    let checkBoxes = []
    let partnerCheckBoxes = []

    Object.keys(offerQueryParameters).map(kennitala => {
        Object.keys(offerQueryParameters[kennitala]).map(insuranceType => {
            if (offerQueryParameters[kennitala][insuranceType]) {
                let key = `${kennitala}-${insuranceType}`
                if (insuranceType === "PARTNER") {
                    partnerCheckBoxes.push(key)
                } else {
                    checkBoxes.push(key)
                }
            }
        })
    })
    if (partnerSeparate) {
        if (partnerCheckBoxes.length > 1) {
            return checkBoxes.concat(partnerCheckBoxes)
        }
        return checkBoxes
    }
    else {
        return checkBoxes.concat(partnerCheckBoxes)
    }
}

export const getCookie = (name) => {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?

            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export const base64ToArrayBuffer = (data) => {
    var binaryString = window.atob(data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};

function ajaxHelper(url, dlStr, elementId, body) {
    let ajaxOptions = {
        url: url,
        success: function (data) {
            if (data) {
                let userAgent = window.navigator.userAgent;

                var arrBuffer = base64ToArrayBuffer(data);
                var a = document.createElement('a');
                var blob = new Blob([arrBuffer], { type: "application/pdf" });

                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
                    window.navigator.msSaveOrOpenBlob(blob, dlStr);
                    if (elementId) {
                        $(elementId).hide()
                    }
                    return;
                } else if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) { // safari & opera on ios
                    let url = window.URL.createObjectURL(blob);
                    window.location.href = url;
                    return;
                }

                window.URL = window.URL || window.webkitURL;
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = dlStr
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                if (elementId) {
                    $(elementId).hide()
                    $(`${elementId}-error`).hide()
                }
            } else {
                console.log("error no data")
                if (elementId) {
                    $(elementId).hide()
                    $(`${elementId}-error`).html("<div class='alert alert-danger'>Engar færslur finnast fyrir umbeðið tímabil</div>")
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log("error")
            if (elementId) {
                $(elementId).hide()
                $(`${elementId}-error`).html("<div class='alert alert-danger'>Engar færslur finnast fyrir umbeðið tímabil</div>")
            }
        }
    }
    $.ajax(ajaxOptions)
}

function ajaxPostHelper(url, dlStr, body, elementId) {

    let ajaxOptions = {
        url: url,
        success: function (data) {
            var arrBuffer = base64ToArrayBuffer(data.base64);
            var blob = new Blob([arrBuffer], { type: data.content_type });
            if (elementId) {
                $(elementId).hide()
            }
            saveAs(blob, dlStr);

        },
        error: function (jqXHR, textStatus, errorThrown) {
            return alert("Það kom upp villa. Vinsamlegast reyndu aftur.");
        }
    }
    if (body) {
        ajaxOptions.method = 'POST'
        ajaxOptions.headers = { 'X-CSRFToken': getCookie("csrftoken"), "cache-control": "no-cache" }
        ajaxOptions.data = JSON.stringify(body)
        ajaxOptions.contentType = 'application/json'
        ajaxOptions.dataType = 'json'
        ajaxOptions.cache = false
        ajaxOptions.processData = false
        ajaxOptions.timeout = 150000
        ajaxOptions.async = true
    }

    $.ajax(ajaxOptions)
}

export const getDeclarationReportPDF = (contractId, date_from, date_to, elementId) => {
    let url = `/api/v1/contracts/${contractId}/declaration/pdf/?date_from=` + date_from + `&date_to=` + date_to;
    let dlStr = `idgjold-` + contractId + `.pdf`;
    ajaxHelper(url, dlStr, elementId);
}

export const getStatusReportPDF = (contractId, elementId) => {
    let url = `/api/v1/contracts/${contractId}/status/pdf/`;
    let dlStr = `stada-` + contractId + `.pdf`;
    ajaxHelper(url, dlStr, elementId)
}

export const getOlderDeclarationReportPDF = (customerId, contractId, recordId) => {
    let url = `/api/v1/contracts/${customerId}/declaration/older/pdf/?record_id=${recordId}&contract_id=${contractId}`;
    let dlStr = `eldri-idgjöld-` + customerId + `-` + recordId + `.pdf`;
    ajaxHelper(url, dlStr);
}

export const getEmployerStatementPDF = (employerId, dateFrom, dateTo, elementId) => {
    let url = `/api/v1/employer/${employerId}/pdf/?date_from=` + dateFrom + `&date_to=` + dateTo;
    let dlStr = `atvinnurekandi-` + employerId + `.pdf`;
    ajaxHelper(url, dlStr, elementId);
}

export const getAccountStatementPDF = (customerId, dateFrom, dateTo, elementId) => {
    let url = `/api/v1/account/${customerId}/pdf/?date_from=` + dateFrom + `&date_to=` + dateTo;
    let dlStr = `reikningsyfirlit-` + customerId + `.pdf`;
    ajaxHelper(url, dlStr, elementId);
}

export const getJournalBankMessagesPDF = (contractId, dateFrom, dateTo, elementId) => {
    let url = `/api/v1/journal/${contractId}/pdf/?date_from=` + dateFrom + `&date_to=` + dateTo;
    let dlStr = `greidsluyfirlit-` + contractId + `.pdf`;
    ajaxHelper(url, dlStr, elementId);
}

export const getPaymentStatementPDF = (contractId, elementId) => {
    let url = `/api/v1/paymentstatement/${contractId}/pdf/`;
    let dlStr = `uttekt-` + contractId + `.pdf`;
    ajaxHelper(url, dlStr, elementId);
}

export const getContractFilePDF = (contractId, recordId, dlStr, elementId) => {
    let url = `/api/v1/mypagescontractfile/${contractId}/${recordId}/`
    ajaxHelper(url, dlStr, elementId);
}


export const getContractOfferPDF = (data) => {

    let url = `/api/v1/contractonlypdf/`;
    let dlStr = `tilbod-${data.customer_id}-${data.offer_type}.pdf`;
    ajaxPostHelper(url, dlStr, data);
}


export const getContractOverviewPDF = (data, elementId) => {

    let url = `/api/v1/contractoverviewpdf/`;
    let dlStr = `allianz-samantekt.pdf`;
    ajaxPostHelper(url, dlStr, data, elementId);
}


export const getStep = (step) => {

    switch (step) {

        case STEP_START:
            return TilbodStepOne

        case STEP_COLLECT_INFO:
            return TilbodStepCollectInfo

        case STEP_SHOW_QUOTE:
            return TilbodStepShowQuote

        case STEP_HEALTH_QUESTIONS:
            return TilbodStepHealthQuestions

        case STEP_PAYMENT:
            return TilbodStepPayment

        case STEP_ID:
            return TilbodStepId

        case STEP_SIGNATURE:
            return TilbodStepSignature

        case STEP_NO_SIGNATURE:
            return TilbodStepNoSigning

        case STEP_FINAL:
            return TilbodStepFinal

        default:
            return TilbodStepOne
    }
}

export const getFullMonthFormat = (m) => {
    let fullMonth = '';
    if (m > 0 && m < 10) {
        fullMonth = "0" + m.toString();
    } else {
        fullMonth = m
    }
    return fullMonth
}

export const checkIfActiveContractForKennitala = (contracts) => {
    let hasActiveContract = false
    Object.values(contracts).map((contract) => {
        contract.map(c => {
            if (CONTRACTS_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                hasActiveContract = true
            }
        })
    })
    return hasActiveContract
}

export const checkIfInActiveVisibleContractForKennitala = (contracts) => {
    let hasActiveContract = false
    Object.values(contracts).map((contract) => {
        contract.map(c => {
            if (CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                hasActiveContract = true
            }
        })
    })
    return hasActiveContract
}

export const makeContractsByKennitala = (contracts) => {

    let ContractsByKennitala = {}

    if (contracts === undefined || contracts === null) {
        return ContractsByKennitala
    }

    for (var contract of contracts.Contract) {
        contract.StartDate = moment.utc(contract.StartDate, "D.M.YYYY")
        contract.DueFrom = moment.utc(contract.DueFrom, "D.M.YYYY")
        if (ContractsByKennitala.hasOwnProperty(contract.CustAccount)) {
            if (ContractsByKennitala[contract.CustAccount].hasOwnProperty(contract.ContractType)) {
                ContractsByKennitala[contract.CustAccount][contract.ContractType].push(contract)
            }
            else {
                ContractsByKennitala[contract.CustAccount][contract.ContractType] = [contract]
            }
        } else {
            let contr = {}
            contr[contract.ContractType] = [contract]
            ContractsByKennitala[contract.CustAccount] = contr
        }
        ContractsByKennitala.Name = contract.Name
    }
    return ContractsByKennitala
}

// Translations

export const getUserTypeTranslations = (type) => {
    switch (type) {
        case 'superuser':
            return 'Stjórnandi'
        case 'regular':
            return 'Almennur'
    }
}

export const getContractNameDetail = (infoCollection, customerId, productCode) => {
    let _productCode = productCode
    if (productCode == 'FOR') {
        _productCode = 'REN'
    }
    if (_productCode !== "REN") {
        if (infoCollection.data[customerId][`${_productCode}onetime`]) {
            return ' (eingreiðslusamningur)'
        } else {
            if (infoCollection.data[customerId]['age'] < 18) {
                return ' fyrir börn og unglinga'
            }
        }
    } else {
        if (infoCollection.data[customerId][`${_productCode}type`] === "onetime") {
            return ' (eingreiðslusamningur)'
        }
    }
    return ''
}

export const getDescriptiveContractName = (id) => {
    let _id = id.toUpperCase()
    switch (_id) {
        case 'KSP':
            return 'Heilsu- og sjúkdómatrygging';
        case 'REN':
            return 'Lífeyrisviðauki Allianz';
        case 'VID':
            return 'Viðbótarlífeyrir Allianz';
        case 'VIDE':
            return 'Viðbótarlífeyrir Allianz (eingreiðslusamningur)';
        case 'VIDT':
            return 'Tilgreind séreign'
        case 'VIDTE':
            return 'Tilgreind séreign (eingreiðslusamningur)'
        case 'LEB':
            return 'Líftrygging með söfnun';
        case 'RISLEB':
            return 'Líftrygging';
        case 'RISLEBSAM':
            return 'Líftrygging fyrir tvo aðila';
        case 'RISU':
            return 'Slysatrygging';
        case 'RIS':
        case 'RU':
        case 'RUP':
        case 'RISU':
        case 'RIS60':
        case 'RISU60':
            return 'Slysatrygging';
        case 'FOR':
            return 'Barnasparnaður Allianz';
        case 'RENE':
            return 'Lífeyrisviðauki Allianz (eingreiðslusamningur)';
        case 'FORE':
            return 'Barnasparnaður Allianz (eingreiðslusamningur)';
        case 'UPR':
        case 'UPRU':
            return 'Slysatrygging með endurgreiddu iðgjaldi'
        default:
            return _id;
    }
}

// ALL = REN,FOR,LEB
// ALLU=RIS,RISU

export const getDescriptivePaymentModeName = (id) => {
    let paymModeTxt = ''
    switch (id) {
        case 'BEIN':
            paymModeTxt = 'Beingreiðsla Landsbankinn'
            break;
        case 'EIN':
            paymModeTxt = 'Eingreiðsla'
            break;
        case 'KORT_ALL':
        case 'KORT_ALLU':   
        case 'KORTV':   // legacy
        case 'KORT':    // legacy
        case 'KortV':   // legacy
            paymModeTxt = 'Kreditkort'
            break;
        case 'LAND':    // legacy
        case 'LI_ALL':
        case 'LI_ALLU':    
            paymModeTxt = 'Greiðsluseðill'
            break;
        case 'MF':
            paymModeTxt = 'Millifært'
            break;
        case 'Motus':
            paymModeTxt = 'Milliinnheimta Motus skilagreinar'
            break;
        case 'SPK':
            paymModeTxt = 'SPK viðbótarlífeyrissparnaður'
            break;
        case 'VÍB':
            paymModeTxt = 'VÍB Innheimtir'
            break;
    }
    return paymModeTxt
}


export const allConfirmsChecked = (customerId, infoCollection, offers) => {
    let confirms = []
    Object.entries(infoCollection.data[customerId]).map(([key, value]) => {
        if (key.toLowerCase().includes("confirm")) {
            if (key !== "confirm") {
                let productCode = key.replace("Confirm", "");
                if (offers.offerQueryParameters[customerId][productCode.toUpperCase()]) {
                    confirms.push(value)
                }
            } else {
                confirms.push(value)
            }

        }
    })

    return confirms.every((val, i) => val === true)
}

// Show blue checkmark in tab only if the
export const allQuotesCalculated = (props, customerId) => {
    let hasCalculated = []
    if (props.offers.offers && props.offers.offers[customerId]) {
        Object.entries(props.offers.offers[customerId]).map(([key, value]) => {
            hasCalculated.push(!value.isFetching && !value.error)
        })
    }
    return hasCalculated.every(val => val === true)
}

export const allIdsConfirmed = (customerId, infoCollection) => {
    let confirms = []
    Object.entries(infoCollection.data[customerId]).map(([key, value]) => {
        if (key === "idStepConfirm") {
            confirms.push(value)
        }
    })
    return confirms.every((val, i) => val === true)
}

export const allCustomersConfirmed = (props) => {

    let ready = []

    for (let customerId of Object.keys(props.offers.offerQueryParameters)) {
        ready.push(allConfirmsChecked(customerId, props.infoCollection, props.offers))
    }

    return ready.every((val) => val === true)
}

export const idConfirmed = (props) => {
    let ready = []

    for (let customerId of Object.keys(props.offers.offerQueryParameters)) {
        ready.push(idStepValid(customerId, props))
    }

    return ready.every((val) => val === true)
}

export const getContractStartDate = (contractType, referenceDate) => {
    if (referenceDate === undefined) {
        referenceDate = moment.utc()
    }

    let startDate

    // Ævilífeyrir: (VID/VIDE) => komið
    // Upphafsdagur alltaf fyrsti þarnæsta mánaðar ef við erum að senda inn fyrstu 2 vikur mánaðarins, eftir það bætist við mánuður: 
    //   Skráður 1.1.2020 – upphafsdagur 1.3.2020
    //   Skráður 14.1.2020 – upphafsdagur 1.3.2020
    //   Skráður 15.1.2020 – upphafsdagur 1.4.2020
    //   Skráður 25.1.2020 – upphafsdagur 1.4.2020

    if (contractType.startsWith("VID")) {
        if (referenceDate.date() < 15) {
            startDate = referenceDate.add(2, 'months')
        } else {
            startDate = referenceDate.add(3, 'months')
        }
    }

    // RisikoLeben: (RISLEB) 
    // Upphafsdagur er fyrsti þarnæsta mánaðar 1.-20., eftir það bætist við mánuður
    //   Skráður 1.1.2020 – upphafsdagur 1.3.2020
    //   Skráður 21.1.2020 – upphafsdagur 1.4.2020

    else if (contractType.startsWith("RISLEB")) {
        if (referenceDate.date() < 21) {
            startDate = referenceDate.add(2, 'months')
        } else {
            startDate = referenceDate.add(3, 'months')
        }
    }

    // Allt annað
    // Upphafsdagur er fyrsti næsta mánaðar ef samningur er skráður 1.-20., eftir það bætist við mánuður
    //   Skráður 1.1.2020 – upphafsdagur 1.2.2020
    //   Skráður 21.1.2020 – upphafsdagur 1.3.2020

    else {
        if (referenceDate.date() < 21) {
            startDate = referenceDate.add(1, 'months')
        } else {
            startDate = referenceDate.add(2, 'months')
        }
    }

    return startDate.set('date', 1).startOf('date');

}

export const getEmployerStartDate = (referenceDate) => {
    if (referenceDate === undefined) {
        referenceDate = moment.utc()
    }
    let day = referenceDate.format("D")
    let month = Number(referenceDate.format("M")) - 1
    month = day < 15 ? month + 1 : month + 2
    let d = referenceDate.month(month).startOf('month')
    return d
}


export const calculateContractlength = (customerId, contractEnd, contractStartDate, contractType) => {

    if (contractStartDate === undefined) {
        return -1
    }

    if (typeof contractStartDate === "string") {
        contractStartDate = moment.utc(contractStartDate, "D.M.YYYY")
    }

    var kt = kennitala.info(customerId)
    var birthday = kt.birthday

    let customerAge = contractStartDate.diff(moment.utc(birthday), 'years', true)

    let customerAgeWithinYear = customerAge % 1
    let contractLength = parseInt(contractEnd) - parseInt(customerAge)
    if (customerAgeWithinYear > 0.5 && contractType !== "KSP") {
        contractLength -= 1
    }

    return contractLength
}

export const getPersonTypeByAge = (customerId) => {
    let kt = kennitala.info(customerId)
    let type = "adult"
    if (kt.age < 18) {
        type = "child"
    }
    return type
}

export const getPersonAge = (customerId) => {
    let kt = kennitala.info(customerId)
    return kt.age
}

export const getPersonAgeByContractDate = (customerId, contractStartDate) => {
    if (!contractStartDate) {
        return null
    }

    let startDate = contractStartDate
    if (typeof startDate === 'string') {
        startDate = moment.utc(startDate, 'D.M.YYYY')
    }

    if (!startDate || !startDate.isValid || !startDate.isValid()) {
        return null
    }

    const kt = kennitala.info(customerId)
    const birthday = kt.birthday
    const customerAge = startDate.diff(moment.utc(birthday), 'years', true)
    if (customerAge % 1 > 0.5) {
        return Math.round(customerAge)
    } else {
        return Math.floor(customerAge)
    }
}



export const shouldShowEducationForm = (customerId, props) => {

    let personType = getPersonTypeByAge(customerId)
    if (personType === "child") {
        return false
    }

    let shouldShow = false
    let activeOffers = Object.keys(props.offers.offerQueryParameters[customerId]).filter(key => props.offers.offerQueryParameters[customerId][key] === true)
    if (activeOffers.includes("KSP") || activeOffers.includes("RISLEB") || activeOffers.includes("LEB") || activeOffers.includes("REN")) {
        shouldShow = true
    }
    return shouldShow
}

// Works for both VID and VIDT
export const checkIfVIDexists = (type, props, customerId) => {
    let onetime = type + 'onetime'
    let idsToMap = Object.keys(props.offers.offers)
    if (customerId !== undefined) {
        idsToMap = [customerId]
    }

    if (!['VID', 'VIDT'].includes(type)) {
        return false
    }

    let vidStop = false
    idsToMap.map(customerId => {

        let hasVID = false
        if (Object.keys(props.offers.offers).includes(customerId)) {
            hasVID = Object.keys(props.offers.offers[customerId]).filter(k => k === type).length > 0
        }

        let offerIsOneTime = props.infoCollection.data[customerId][onetime]
        if (hasVID && !offerIsOneTime) {
            let customer = props.customers.customerList.filter(c => c.Customer.AccountNum == customerId)

            if (customer.length > 0) {
                if (customer[0].ContractsByKennitala[customerId][type] !== undefined) {
                    if (customer[0].ContractsByKennitala[customerId][type].filter(contr => CONTRACT_STATUS_WAITING.includes(contr.ContractStatusId)).length > 0) {
                        vidStop = true
                    }
                    if (customer[0].ContractsByKennitala[customerId][type].filter(contr => CONTRACT_STATUS_ACTIVE.includes(contr.ContractStatusId)).length > 0) {
                        vidStop = true
                    }
                }
            }
        }
    })
    return vidStop
}

export const hasAtLeastOneEmployer = (employers, customerId, contractType) => {
    try {
        let foundEmployerIds = Object.keys(employers.employers[customerId])
        let correctEmployerTypeIds = foundEmployerIds.filter(f => employers.employers[customerId][f].employer.contractType === contractType)
        return correctEmployerTypeIds.length > 0
    } catch (e) {
        return false
    }
}


export const shouldShowPayerEmployerCheckmark = (props, productCode, customerId) => {
    if (productCode === "VID" && props.infoCollection.data[customerId]["VIDonetime"] === true) {
        return true
    } else if (productCode === "VID" && props.infoCollection.data[customerId]["VIDonetime"] === false && hasAtLeastOneEmployer(props.employers, customerId, "VID")) {
        return true
    }

    if (productCode === "VIDT" && props.infoCollection.data[customerId]["VIDTonetime"] === true) {
        return true
    } else if (productCode === "VIDT" && props.infoCollection.data[customerId]["VIDTonetime"] === false && hasAtLeastOneEmployer(props.employers, customerId, "VIDT")) {
        return true
    }

    if (productCode !== "VID" && productCode !== "VIDT") {
        if (props.payers.payerProductMapping[customerId] && props.payers.payerProductMapping[customerId][productCode]) {
            return true
        }
    }
    return false
}

export const singleSignerComplete = (signerId, contractData) => {
    let signerContracts = contractData.contract_files.filter(f => f.signer_id === signerId).filter(f => f.active)
    let allContractSigned = []
    if (!contractData.paper_signing) {
        for (var c of signerContracts) {
            if (c.signing_needed) {
                allContractSigned.push(c.status === 'contract_signed' || c.status === 'contract_delivered')
            } else {
                allContractSigned.push(true)
            }
        }
    } else {
        for (var c of signerContracts) {
            allContractSigned.push(c.status === 'contract_downloaded')
        }
    }
    if (allContractSigned.length === 0) {
        return false
    }
    return allContractSigned.every((v) => v === true)
}

export const allSignersComplete = (contractData) => {
    if (contractData.error) {
        return false
    }
    const signers = [... new Set(contractData.contract_files.map(c => {
        if (c.signing_needed || contractData.paper_signing) {
            return c.signer_id
        }
    }).filter(f => f !== undefined))]
    let allSignersSigned = []
    for (var s of signers) {
        allSignersSigned.push(singleSignerComplete(s, contractData))
    }
    if (allSignersSigned.length === 0) {
        return false
    }
    return allSignersSigned.every((v) => v === true)
}


export const singlePayerConfirmed = (offers, kennitala, employers, payers, infoCollection) => {
    let allSinglePayerConfirms = []
    for (var offerType of Object.keys(offers.offerQueryParameters[kennitala])) {
        if (offers.offerQueryParameters[kennitala][offerType] === true) {

            if (offerType === "VID" || offerType === "VIDT") {
                let oneTime = offerType === "VID" ? "VIDonetime" : "VIDTonetime"
                if (infoCollection.data[kennitala][oneTime] === true) {
                    allSinglePayerConfirms.push(true)
                } else if (infoCollection.data[kennitala][oneTime] === false) {
                    if (employers.employers[kennitala] === undefined) {
                        allSinglePayerConfirms.push(false)
                    } else if (employers.employers[kennitala] !== undefined) {
                        if (hasAtLeastOneEmployer(employers, kennitala, offerType)) {
                            allSinglePayerConfirms.push(true)
                        } else {
                            allSinglePayerConfirms.push(false)
                        }
                    }
                }
            }

            if (offerType !== "VID" && offerType !== "VIDT") {
                if (payers.payerProductMapping[kennitala] === undefined) {
                    allSinglePayerConfirms.push(false)
                } else {
                    if (payers.payerProductMapping[kennitala][offerType]) {
                        allSinglePayerConfirms.push(true)
                    } else {
                        allSinglePayerConfirms.push(false)
                    }
                }
            }
        }
    }
    return allSinglePayerConfirms.every((v) => v === true)
}

export const anyAnswerInGroupTrue = (groupCond, groupTitle, healthQuestions, customerId, offerType) => {
    let values = []

    if (healthQuestions.groups[customerId] && healthQuestions.groups[customerId][offerType] && healthQuestions.groups[customerId][offerType][groupTitle] && healthQuestions.groups[customerId][offerType][groupTitle][groupCond]) {
        Object.values(healthQuestions.groups[customerId][offerType][groupTitle][groupCond]).map((val) => {
            if (Array.isArray(val)) {
                val.map((v) => {
                    Object.values(v).map(vv => values.push(vv))
                })
            } else {
                values.push(val)
            }
        })
    }
    return values.includes("true")
}

export const shouldBeValidated = (offerType, infoCollection, blockdisplayCondition, customerId) => {
    let validate = true;
    if (blockdisplayCondition === "if NOT single payment") {
        if (offerType === 'VID' && (infoCollection.VIDonetime || (infoCollection.data && infoCollection.data[customerId].VIDonetime))) {
            validate = false
        }
        if (offerType === 'VIDT' && (infoCollection.VIDTonetime || (infoCollection.data && infoCollection.data[customerId].VIDTonetime))) {
            validate = false
        }
        if ((offerType === 'REN' || offerType === 'FOR' || offerType === 'REND' || offerType === 'FORD') && (infoCollection.RENtype === 'onetime' || (infoCollection.data && infoCollection.data[customerId].RENtype === 'onetime'))) {
            validate = false
        }
    }
    return validate
}

export const isSinglePayment = (offerType, infoCollection) => {
    let singlePayment = false;
    if ((offerType === 'VID' && infoCollection.VIDonetime) || (offerType === 'VIDT' && infoCollection.VIDTonetime) || ((offerType === 'REN' || offerType === 'FOR' || offerType === 'REND' || offerType === 'FORD') && infoCollection.RENtype === 'onetime')) {
        singlePayment = true;
    }
    return singlePayment
}

export const isMainQuestiongroupConfirmed = (value, infoCollection, healthQuestions, customerId, offerType, offers) => {
    let allSubGroups = [];
    value.map(question_package => {
        question_package.value.question_groups.map((qg) => {
            allSubGroups.push(areHealthQuestionsConfirmed(qg, infoCollection, healthQuestions, customerId, offerType, offers))
            allSubGroups.push(isAnySinglePaymentCheckboxChecked(qg, infoCollection, healthQuestions, customerId, offerType))
        })
    })
    return allSubGroups.every((val) => val === true)
}

export const isAnySinglePaymentCheckboxChecked = (questionGroup, infoCollection, healthQuestions, customerId, offerType) => {
    let singlePaymentQuestions = [];

    questionGroup.questions.map((q) => {
        if (q.value.display_condition === "if single payment" && q.type !== 'text_block' && isSinglePayment(offerType, infoCollection, customerId)) {
            singlePaymentQuestions.push(q.id);
        }
    })

    let values = []
    if (healthQuestions.data[customerId] && healthQuestions.data[customerId][offerType]) {
        singlePaymentQuestions.map((spq) => {

            if (Object.keys(healthQuestions.data[customerId][offerType]).includes(spq)) {
                values.push(Object.values(healthQuestions.data[customerId][offerType][spq][0])[0])
            }
        })
    }
    let anyCheckboxChecked = false;
    if (singlePaymentQuestions.length === 0) {
        anyCheckboxChecked = true;
    } else {
        anyCheckboxChecked = values.includes("true")
    }
    return anyCheckboxChecked;
}

export const contractPaymentTypeMatch = (displayCondition, offerType, infoCollection, customerId) => {
    let isSingle = false
    if (displayCondition === "if single payment") {
        isSingle = true
    }
    switch (offerType) {
        case 'VID':
            return infoCollection.VIDonetime === isSingle || (infoCollection.data && infoCollection.data[customerId].VIDonetime === isSingle)
        case 'VIDT':
            return infoCollection.VIDTonetime === isSingle || (infoCollection.data && infoCollection.data[customerId].VIDTonetime === isSingle)
        case 'REN':
        case 'FOR':
        case 'REND':
        case 'FORD':
            return (infoCollection.RENtype === 'onetime') === isSingle || (infoCollection.data && infoCollection.data[customerId].RENtype === 'onetime') === isSingle
        case 'RISLEB':
        case 'RIS':
        case 'LEB':
        case 'KSP':
            return !isSingle
        default:
            return false
    }
}

export const checkDisplayCondition = (dispCond, groupTitle, healthQuestions, customerId, offerType) => {
    if (dispCond.includes("any true in")) {
        let conditionArr = dispCond.split(' ')
        if (conditionArr.includes('or')) {
            let orIndex = conditionArr.indexOf('or')
            let firstLetter = conditionArr[orIndex - 1]
            let secondLetter = conditionArr[orIndex + 1]
            return (anyAnswerInGroupTrue(firstLetter, groupTitle, healthQuestions, customerId, offerType) || anyAnswerInGroupTrue(secondLetter, groupTitle, healthQuestions, customerId, offerType))
        }
        // if(conditionArr.includes("&&")){
        //     let letter = conditionArr[3]
        //     let answerInGroupTrue = anyAnswerInGroupTrue(letter, groupTitle, healthQuestions, customerId, offerType)
        //     let show_error_or_ok = false
        //     if(conditionArr.includes('sustainability_error')){
        //         let required_value = conditionArr[conditionArr.length - 1]
        //         if(Object.keys(healthQuestions.data).length > 0){
        //             let curr_val = healthQuestions.data[customerId][offerType]
        //             debugger
        //         }
        //         else return false
        //     }
        //     return true
        // } 
        else {
            let letter = conditionArr[conditionArr.length - 1]
            return anyAnswerInGroupTrue(letter, groupTitle, healthQuestions, customerId, offerType)
        }
    }
    return false
}

export const noSpecificDispCond = (dispCond) => {
    return dispCond === "false=show_stopper" || dispCond === "true=show_stopper" || dispCond === "false=show_stopper_origin" || dispCond === "true=show_stopper_origin" || dispCond === "" || dispCond === undefined || dispCond === "must check"
}

export const areHealthQuestionsConfirmed = (group, infoCollection, healthQuestions, customerId, offerType, offers, dispatchQuestionCheck) => {
    let allAnsweredQuestions = [];
    let groupedQuestions = {};
    if (group) {
        if (group.questions.length === 0) {
            allAnsweredQuestions.push(true)
        } else {
            group.questions.map((q) => {
                let blockType = q.type;
                let block = q.value;
                let blockId = q.id;
                let blockdisplayCondition = q.value.display_condition;
                let subgroup = q.value.subgroup;
                let onlyDispOnCondition = q.value.display_on_condition;

                if (block.extra_classes && block.extra_classes.includes("one_should_be_checked")) {
                    let groupId = block.extra_classes.match(/one_should_be_checked_(\S+)/)[1]
                    if (groupId !== undefined) {
                        if (Object.keys(groupedQuestions).includes(groupId)) {
                            groupedQuestions[groupId].push(q)
                        } else {
                            groupedQuestions[groupId] = [q]
                        }
                    }
                }

                if (blockType !== "text_block" && (
                    (subgroup === 'C' && offerType === 'KSP' && isGesamtRenteHigherThanLimit(18000, offerType, offers, customerId))
                    || noSpecificDispCond(blockdisplayCondition)
                    // || (onlyDispOnCondition && dispCondMatchesPortfolioType(blockdisplayCondition))

                    || checkDisplayCondition(blockdisplayCondition, group.title, healthQuestions, customerId, offerType)
                    || (subgroup === 'C' && (offerType === 'LEB' || offerType === 'RISLEB') && (parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteTodesfallleistung"]) > 200000))
                    || (subgroup === 'D' && offerType === 'RISLEB' && ((parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteTodesfallleistung"]) > 500000) || ((parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteTodesfallleistung"]) * parseFloat(offers.offers[customerId][offerType].keyFigures.Wert["UZ"])) / 100 > 500000)))
                    || (subgroup === 'D' && offerType === 'LEB' && (parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteTodesfallleistung"]) > 500000))
                    || (subgroup === 'D' && offerType === 'LEB' && infoCollection['LEBunits'] === 'percentage' && (parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteTodesfallleistung"]) * parseFloat(offers.offers[customerId][offerType].keyFigures.Wert["UZ"]) / 100 > 500000))
                    || (subgroup === 'D' && offerType === 'LEB' && infoCollection['LEBunits'] === 'currency' && (parseFloat(offers.offers[customerId][offerType].keyFigures.Wert["UZ"]) > 500000))
                    || (onlyDispOnCondition && blockdisplayCondition.includes("yearly pension > 18000") && (parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteRente"] * 12) > 18000))
                    || (onlyDispOnCondition && blockdisplayCondition.includes("yearly pension > 24000") && (parseFloat(offers.offers[customerId][offerType].keyFigures["GarantierteRente"] * 12) > 24000))
                    || ((offerType !== 'KSP' || offerType !== 'RISLEB') && blockdisplayCondition === "if offer_type != KSP, RISLEB")
                    || (offerType === 'VID' && blockdisplayCondition.includes( "if offer_type == ") && blockdisplayCondition.includes( "VID"))
                    || (offerType === 'VIDT' && blockdisplayCondition.includes( "if offer_type == ") && blockdisplayCondition.includes( "VIDT"))
                    || (blockdisplayCondition === "if single payment" || blockdisplayCondition === "if NOT single payment") && contractPaymentTypeMatch(blockdisplayCondition, offerType, infoCollection, customerId)
                )
                ) {

                    if (blockType === 'lookup_block') {
                        block.return_values.map((val) => {
                            if (healthQuestions.data[customerId] && healthQuestions.data[customerId][offerType]) {
                                if (healthQuestions.data[customerId][offerType][blockId + "-" + val]) {
                                    allAnsweredQuestions[blockId + "-" + val] = true
                                } else {
                                    allAnsweredQuestions[blockId + "-" + val] = false
                                }
                                if (healthQuestions.data[customerId][offerType][blockId + "-ssn"]) {
                                    allAnsweredQuestions[blockId + "-ssn"] = true
                                } else {
                                    allAnsweredQuestions[blockId + "-ssn"] = false
                                }
                            }
                        })
                    } else {
                        let conditions = block.conditions;
                        let type = block.question_type;
                        let title = block.title;
                        let lastValueInArray = block.questions[block.questions.length - 1].label;

                        if (healthQuestions.data[customerId] && healthQuestions.data[customerId][offerType] && shouldBeValidated(offerType, infoCollection, blockdisplayCondition, customerId)) {
                            if (healthQuestions.data[customerId][offerType][blockId]) {
                                allAnsweredQuestions[blockId] = true
                            } else {
                                allAnsweredQuestions[blockId] = false
                            }

                            if (type == "lookup_dropdown") {
                                let thisQuestionAnswered = []
                                block.questions.map((q, i) => {
                                    if (healthQuestions.data[customerId][offerType][`${blockId}-${i}`]) {
                                        thisQuestionAnswered.push(true)
                                    } else {
                                        thisQuestionAnswered.push(false)
                                    }
                                })
                                if (thisQuestionAnswered.every((val) => val === true)) {
                                    allAnsweredQuestions[blockId] = true
                                } else {
                                    allAnsweredQuestions[blockId] = false
                                }
                            }

                            if (type == "checkboxes" || type === "checkbox") {
                                if (block.display_on_condition && block.display_condition.includes("must check")) {
                                    block.questions.map((q, i) => {
                                        if (healthQuestions.data[customerId][offerType][blockId] && healthQuestions.data[customerId][offerType][blockId][i] && Object.values(healthQuestions.data[customerId][offerType][blockId][i])[0] === "true") {
                                            allAnsweredQuestions[blockId + '-' + i] = true
                                        } else {
                                            allAnsweredQuestions[blockId + '-' + i] = false
                                        }
                                    })
                                } else {
                                    block.questions.map((q, i) => {
                                        if (healthQuestions.data[customerId][offerType][blockId][i]) {
                                            allAnsweredQuestions[blockId + '-' + i] = true
                                        } else {
                                            allAnsweredQuestions[blockId + '-' + i] = false
                                        }
                                    })
                                }
                            }

                            if ((type === "singleline" || type === "singlelineEUR" || type === "multiline") && title !== "" && block.questions.length > 1) {
                                delete allAnsweredQuestions[blockId];
                                block.questions.map((q, index) => {
                                    if (healthQuestions.data[customerId][offerType][blockId + "-" + index]) {
                                        allAnsweredQuestions[blockId + "-" + index] = true
                                    } else {
                                        allAnsweredQuestions[blockId + "-" + index] = false
                                    }
                                })
                            }

                            if ((type === "yes_no" || type === "radio" || type === "checkboxes" || type === "checkbox") && conditions.length > 0) {
                                conditions.map((condition) => {
                                    let accessor = condition
                                    if (condition.value) {
                                        accessor = condition.value
                                    }
                                    accessor.conditional_question.map((cond, i) => {
                                        let conditionType = cond.type;
                                        if (conditionType === "conditional_lookup") {
                                            cond.value.return_values.map((val) => {
                                                if (healthQuestions.data[customerId] && healthQuestions.data[customerId][offerType]) {
                                                    if (healthQuestions.data[customerId][offerType][blockId] === "true") {
                                                        if (healthQuestions.data[customerId][offerType][blockId + "-" + val]) {
                                                            allAnsweredQuestions[blockId + "-" + val] = true
                                                        } else if (!healthQuestions.data[customerId][offerType][blockId + "-" + val]) {
                                                            allAnsweredQuestions[blockId + "-" + val] = false
                                                        }
                                                        if (healthQuestions.data[customerId][offerType][blockId + "-ssn"]) {
                                                            allAnsweredQuestions[blockId + "-ssn"] = true
                                                        } else if (!healthQuestions.data[customerId][offerType][blockId + "-ssn"]) {
                                                            allAnsweredQuestions[blockId + "-ssn"] = false
                                                        }
                                                    } else if (healthQuestions.data[customerId][offerType][blockId] === "false") {
                                                        if (healthQuestions.data[customerId][offerType][blockId + "-" + val]) {
                                                            delete allAnsweredQuestions[blockId + "-" + val]
                                                        }
                                                        if (healthQuestions.data[customerId][offerType][blockId + "-ssn"]) {
                                                            delete allAnsweredQuestions[blockId + "-ssn"]
                                                        }
                                                    }
                                                }
                                            })
                                        } else {
                                            if (healthQuestions.data[customerId][offerType][blockId + "-" + i]) {
                                                allAnsweredQuestions[blockId + "-" + i] = true
                                            } else if (!healthQuestions.data[customerId][offerType][blockId + "-" + i]) {
                                                allAnsweredQuestions[blockId + "-" + i] = false
                                            }
                                        }


                                        if (type === "checkbox" || type === "checkboxes") {
                                            if (accessor.condition === "anyTrue" && healthQuestions.data[customerId][offerType][blockId].find(e => Object.values(e)[0] !== "true")) {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }

                                            if (accessor.condition === "anyFalse" && healthQuestions.data[customerId][offerType][blockId].find(e => Object.values(e)[0] !== "false")) {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }

                                            if (accessor.condition === "lastTrue" && Object.values(healthQuestions.data[customerId][offerType][blockId].slice(-1)[0])[0] === "false") {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }
                                        } else {
                                            if (accessor.condition === "anyTrue" && healthQuestions.data[customerId][offerType][blockId] === 'false') {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }

                                            if (accessor.condition === "anyFalse" && healthQuestions.data[customerId][offerType][blockId] === 'true') {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }

                                            if (accessor.condition === "lastTrue" && healthQuestions.data[customerId][offerType][blockId] !== lastValueInArray) {
                                                delete allAnsweredQuestions[blockId + "-" + i]
                                            }
                                        }

                                    })
                                })
                            }
                        }
                    }
                } else {
                    delete allAnsweredQuestions[blockId]
                }
            })
        }
        if (dispatchQuestionCheck) {
            store.dispatch(exportAnsweredQuestions(customerId, offerType, group, allAnsweredQuestions))
        }
    }

    // Check for sjalfbaerni
    if (healthQuestions.data[customerId] && healthQuestions.data[customerId][offerType] && Object.keys(healthQuestions.data[customerId][offerType]).includes("7b3180d3-ea62-49b3-b6e1-ba75f4a6b056") && healthQuestions.data[customerId][offerType]['7b3180d3-ea62-49b3-b6e1-ba75f4a6b056'] == "true") {
        let valid = false
        /* then we check if at least one of the parent questions is selected */
        if (Object.keys(groupedQuestions).includes("parent")) {
            let groupvalues = groupedQuestions.parent.map((gq) => {
                if (Object.keys(healthQuestions.data[customerId][offerType]).includes(gq.id) && healthQuestions.data[customerId][offerType][gq.id].length > 0 && Object.values(healthQuestions.data[customerId][offerType][gq.id][0])[0] === "true") {
                    /* then we check if that question has children defined and do the same to them */
                    let returnval = 'H'
                    let childrenId = gq.value.extra_classes.match(/childrenid_(\S+)/)[1]
                    if (childrenId !== undefined) {
                        if (Object.keys(groupedQuestions).includes(childrenId)) {
                            let childrenvalues = groupedQuestions[childrenId].map((cq) => {
                                if (cq.value.question_type === "checkboxes" || cq.value.question_type === "checkbox") {
                                    if (Object.keys(healthQuestions.data[customerId][offerType]).includes(cq.id) && healthQuestions.data[customerId][offerType][cq.id].length > 0) {
                                        let anwers = healthQuestions.data[customerId][offerType][cq.id].map((a) => {
                                            if (Object.values(a)[0] === "true") {
                                                return true
                                            }
                                            return false
                                        })
                                        return anwers.includes(true)
                                    }
                                } else if (cq.value.question_type === "radio") {
                                    if (Object.keys(healthQuestions.data[customerId][offerType]).includes(cq.id)) {
                                        return true
                                    }
                                }
                                return false
                            })
                            if (childrenvalues.includes(true)) {
                                returnval = 'U'
                            }
                            return returnval
                        }
                    }
                }
                return false
            })
            if (groupvalues.includes('U') && !groupvalues.includes('H')) {
                valid = true
            }
            allAnsweredQuestions["7b3180d3-ea62-49b3-b6e1-ba75f4a6b056"] = valid
        }
    }
    let ready = false
    if (Object.keys(allAnsweredQuestions).length > 0) {
        ready = Object.keys(allAnsweredQuestions).every((q) => allAnsweredQuestions[q] === true)
    }

    return ready;
}

export const hasAnyQuestions = (customerId, props) => {
    let hasQuestions = false
    Object.keys(props.offers.offerQueryParameters[customerId]).filter((off) => props.offers.offerQueryParameters[customerId][off] === true).map((productCode, idx) => {
        let _productCode = productCode
        if (['FOR', 'REN'].includes(productCode)) {
            if (props.infoCollection.data[customerId]['RENdeathbenefits'] === true) {
                _productCode = `${_productCode}D`
            }
        }
        if (props.healthQuestions.results[_productCode] !== undefined && props.healthQuestions.results[_productCode] !== null && props.healthQuestions.results[_productCode].length > 0) {
            // if (_productCode === "REN") {
            //   if (props.infoCollection.data[customerId]['RENdeathbenefits'] === true) {
            //     hasQuestions = true
            //   }
            // } else {
            // }
            hasQuestions = true
        }
    })
    return hasQuestions
}


export const allHealthQuestionGroupsChecked = (customerId, offers, infoCollection, healthQuestions) => {
    let allGroups = []
    let dispatchQuestionCheck = false;
    Object.keys(offers.offerQueryParameters[customerId]).filter((off) => offers.offerQueryParameters[customerId][off] === true).map((productCode, idx) => {
        Object.entries(healthQuestions.results).map(([k, v]) => {
            let _productCode = productCode
            if (['FOR', 'REN'].includes(productCode)) {
                if (infoCollection.data[customerId]['RENdeathbenefits'] === true) {
                    _productCode = `${_productCode}D`
                }
            }
            if (k === _productCode && v && v.length > 0 && v !== null) {
                v.map((insurance_package) => {
                    insurance_package.value.question_groups.map((questionGroup) => {
                        if (!questionGroup.display_on_condition) {
                            allGroups.push(areHealthQuestionsConfirmed(questionGroup, infoCollection, healthQuestions, customerId, _productCode, offers, dispatchQuestionCheck))
                            allGroups.push(isAnySinglePaymentCheckboxChecked(questionGroup, infoCollection, healthQuestions, customerId, _productCode))
                        }
                    })
                })
            } else {
                allGroups.push(true)
            }
        })
    })
    return allGroups.every(val => val === true)
}

export const allHealthQuestionsConfirmed = (props) => {
    let ready = []
    let dispatchQuestionCheck = false;

    if (props.healthQuestions.isFetching) {
        ready.push(false)
    }

    for (let customerId of Object.keys(props.offers.offerQueryParameters)) {
        ready.push(allHealthQuestionGroupsChecked(customerId, props.offers, props.infoCollection, props.healthQuestions, dispatchQuestionCheck))
    }

    return ready.every((val) => val === true)
}

export const isBeneficiaryValidForCustomer = (customerId, props) => {
    let ready = []
    for (let offerType of Object.keys(props.offers.offerQueryParameters[customerId]).filter((off) => props.offers.offerQueryParameters[customerId][off] === true && offerTypesForBeneficiaries.includes(off))) {
        ready.push(isBeneficiaryValid(customerId, offerType, props.infoCollection))
    }
    return ready.every((val) => val === true)
}

export const isBeneficiaryValid = (customerId, offerType, infoCollection) => {
    let _offerType = offerType
    if (offerType === "FOR") {
        _offerType = "REN"
    }
    if (["10", "20", "30"].includes(infoCollection.data[customerId][`${_offerType}deathbenefitsbeneficiary`])) {
        return true
    }
    if (infoCollection.data[customerId][`${_offerType}deathbenefitsbeneficiary`] === "40") {
        let isValid = false;
        const kennitolur = infoCollection.data[customerId][`${_offerType}deathbenefitsbeneficiaryOrgId`];
        if (kennitolur.length > 0) {
            isValid = true;
            kennitolur.forEach((kt) => {
                isValid = isValid && kennitala.isValid(kt);
            })
        }
        return isValid;
    }
    return false
}


export const allBeneficiaryValid = (props) => {
    let ready = []

    for (let customerId of Object.keys(props.offers.offerQueryParameters)) {
        for (let offerType of Object.keys(props.offers.offerQueryParameters[customerId]).filter((off) => props.offers.offerQueryParameters[customerId][off] === true && offerTypesForBeneficiaries.includes(off))) {
            ready.push(isBeneficiaryValid(customerId, offerType, props.infoCollection))
        }
    }

    return ready.every((val) => val === true)
}


export const allPayersConfirmed = (props) => {
    let allPayerConfirms = []

    for (var kennitala of Object.keys(props.offers.offerQueryParameters)) {
        allPayerConfirms.push(singlePayerConfirmed(props.offers, kennitala, props.employers, props.payers, props.infoCollection))
    }
    return allPayerConfirms.every((v) => v === true)
}

export const singleCustomerErrors = (offers, kennitala) => {
    let allCustomerErrors = []
    for (var offerType of Object.keys(offers.offerQueryParameters[kennitala])) {
        if (offers.offerQueryParameters[kennitala][offerType] === true) {
            if (offers.offers[kennitala] !== undefined && offers.offers[kennitala][offerType] !== undefined) {
                allCustomerErrors.push(offers.offers[kennitala][offerType]["error"])
                allCustomerErrors.push(offers.offers[kennitala][offerType].isFetching)
            }
        }
    }
    return allCustomerErrors.some((v) => v === true)
}

export const offerErrors = (props) => {
    let allErrors = []

    for (var kennitala of Object.keys(props.offers.offerQueryParameters)) {
        allErrors.push(singleCustomerErrors(props.offers, kennitala))
    }
    return allErrors.some((v) => v === true)

}

export const offerErrorsByOfferType = (props, customerId) => {
    let allErrors = {}
    let offers = props.offers

    for (var kennitala of Object.keys(offers.offerQueryParameters)) {
        if (kennitala === customerId) {
            for (var offerType of Object.keys(offers.offerQueryParameters[kennitala])) {
                if (offers.offerQueryParameters[kennitala][offerType] === true) {
                    if (offers.offers[kennitala] !== undefined && offers.offers[kennitala][offerType] !== undefined) {
                        allErrors[offerType] = offers.offers[kennitala][offerType]["error"]
                        // allCustomerErrors.push(offers.offers[kennitala][offerType].isFetching)
                    }
                }
            }
        }

    }
    return allErrors
}


export const contactInfoConfirmed = (props) => {
    let ready = []

    for (let customerId of Object.keys(props.infoCollection.data)) {
        if (props.offers.offerQueryParameters[customerId] !== undefined && Object.keys(props.offers.offerQueryParameters[customerId]).filter((off) => props.offers.offerQueryParameters[customerId][off] === true).length > 0) {
            if (getPersonTypeByAge(customerId) !== "child") {
                ready.push(props.insuranceTakers.insuranceTakers[customerId].contactInfoConfirm)
            }
        }
    }

    return ready.every((val) => val === true)
}


export const idStepValid = (customerId, props) => {
    let confirms = []

    for (let offerType of Object.keys(props.offers.offerQueryParameters[customerId]).filter((off) => props.offers.offerQueryParameters[customerId][off] === true)) {
        if (getPersonTypeByAge(customerId) === "child" && offerType === "FOR") {
            offerType = "REN"
        }

        let insuranceTaker = props.insuranceTakers.insuranceTakers[props.infoCollection.data[customerId][`${offerType}insuranceTaker`]]
        if (insuranceTaker["useExistingPhotoId"]) {
            confirms.push(true)
            confirms.push(insuranceTaker["taxInfoConfirm"])
        }
        if (offerType == "RIS") { // RIS insurers do not need ID
            confirms.push(true)
        } else {
            if (!insuranceTaker["useExistingPhotoId"]) {
                confirms.push(insuranceTaker["confirm"])
            }
            confirms.push(insuranceTaker["taxInfoConfirm"])
        }
        confirms.push(insuranceTaker["contactInfoConfirm"])

    }
    return confirms.every((val) => val === true)
}

export const copyToClipboard = str => {
    const el = document.createElement('textarea');  // Create a <textarea> element
    el.value = str;                                 // Set its value to the string that you want copied
    el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px';                      // Move outside the screen to make it invisible
    document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
    const selected =
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0)     // Store selection if found
            : false;                                    // Mark as false to know no selection existed before
    el.select();                                    // Select the <textarea> content
    document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el);                  // Remove the <textarea> element
    if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected);   // Restore the original selection
    }
};


export const isGesamtRenteHigherThanLimit = (limit, offerType, offers, customerId) => {
    let isHigherThanLimit = false;
    let yearlyGesamtRente = parseInt(offers.offers[customerId][offerType]['keyFigures']['GesamteRente']) * 12;

    if (yearlyGesamtRente > limit) {
        isHigherThanLimit = true
    }
    return isHigherThanLimit;
}

export const validatePhoneNumber = (phoneNumber) => {
    let phoneCheck = /^[0-9]{7}$/
    return phoneNumber.length === 7 && (RegExp(phoneCheck).test(phoneNumber))
}

export const validateEmail = (emailAddress) => {
    let emailCheck = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return RegExp(emailCheck).test(emailAddress) && emailAddress.length > 0
}

export const EmptyMyPages = () => {
    return (
        <div className="container">
            <div className="row justify-content-center xs-pb-40">
                <div className="col-12 text-center">
                    <img className="img-fluid" src={window.images.myPagesEmpty} />
                </div>
            </div>
            <div className="row justify-content-center xs-pb-40">
                <div className="col-12 col-sm-4 text-center">
                    <p>Þú ert því miður ekki með neinar tryggingar skráðar hjá Allianz á Íslandi. Má bjóða þér viðtal við ráðgjafa?</p>
                    <p>Ef um skráningarvillu er að ræða vinsamlegast hafið samband við skrifstofu Allianz s: <a href="tel:+3545953300">595-3300</a>.</p>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-sm-4 col-12 text-center">
                    <a className="btn btn-primary" href="/fá-ráðgjöf/">Panta ráðgjöf</a>
                </div>
            </div>
        </div>
    )
}

export const calculateAgeFromKennitala = (kennitala, reference = null) => {
    var day = kennitala.substring(0, 2);
    if (day > 31) {
        day = day - 40;
    }
    var month = kennitala.substring(2, 4);
    var year = (kennitala.substring(9, 10) == 0 ? 20 : 19) + kennitala.substring(4, 6);
    var birthday = `${year}-${month}-${day}`
    var today = moment.utc()
    if (reference !== null) {
        today = reference
    }
    return today.diff(birthday, 'years')
}

export const Tooltip = (props) => {
    return (
        <span className={props.className} data-toggle={"tooltip"} data-placement={props.placement} data-original-title={props.text} title={props.text}>
            <div className="tooltip-icon-container">
                    <SvgInfoIcon/>
            </div>
        </span>
    )
}

Tooltip.defaultProps = {
    className: '',
    placement: 'top'
}

export const getInitials = (name) => {
    let nameParts = name.split(" ")
    let initials = nameParts.map(n => n.substring(0, 1))
    return initials.join("")
}

export const htmlDecode = (input) => {
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}


export const getContractFile = (recId, customerOffers) => {
    let cf = null
    if (customerOffers) {
        customerOffers.offers.map((o) => {
            let filtered = o.contract_files.filter((cf) => cf.ax_rec_id === recId)
            if (filtered.length > 0) {
                cf = filtered[0]
            }
        })
    }
    return cf
}


export const countUnsignedAxDocuments = (signingRecords, customerOffers) => {
    let counter = 0;
    let contractFiles = {}
    if (signingRecords && signingRecords.data && signingRecords.data.Customer && signingRecords.data.Customer.ElectronicSignatureList) {
        const { ElectronicSignature } = signingRecords.data.Customer.ElectronicSignatureList
        if (ElectronicSignature) {
            ElectronicSignature.map((signatureRequest) => {
                let c = getContractFile(signatureRequest.RecId, customerOffers)
                if (c) {
                    contractFiles[signatureRequest.RecId] = c
                }
            })
        }
        counter = signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature.length
        signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature.map(signatureRequest => {
            if (contractFiles[signatureRequest.RecId] && (!contractFiles[signatureRequest.RecId].signing_needed || contractFiles[signatureRequest.RecId].signing_needed && contractFiles[signatureRequest.RecId].status === 'contract_signed' || contractFiles[signatureRequest.RecId].signing_needed && contractFiles[signatureRequest.RecId].status === 'contract_delivered')) {
                counter--;
            }
        })
    }
    return counter
}

export const plural = (number) => {
    if (number === 11) {
        return true
    }
    if (number % 10 === 1) {
        return false
    }
    return true
}

export const calculateTotalMonthlyPayment = (offerProps, infoCollection, customerId) => {

    let _infoCollection = infoCollection.data[customerId]

    let offerQueryParameters = offerProps.offerQueryParameters[customerId] || {}
    let offers = offerProps.offers[customerId] || {}

    let activeOffers = Object.keys(offerQueryParameters).filter(oqp => offerQueryParameters[oqp] === true)

    let paymentFrequencyRatio = {
        "monthly": 1,
        "yearly": 12,
        "quarterly": 3,
        "every6months": 6,
    }

    let isOnetime = (_infoCollection, offerType) => {
        return _infoCollection[`${offerType}onetime`] === true || _infoCollection[`${offerType}type`] === "onetime"
    }

    let sum = 0.0
    Object.keys(offers).map(k => {
        if (activeOffers.includes(k)) {
            if (!isOnetime(_infoCollection, k)) {
                let ratio = 1
                let specificRatio = _infoCollection[`${k}paymentfrequency`]
                if (specificRatio !== undefined) {
                    ratio = paymentFrequencyRatio[specificRatio]
                }
                sum += parseFloat(offers[k]["keyFigures"]["Hauptprodukt"]) / ratio
            }
        }
    })

    let childSum = 0.0

    Object.keys(infoCollection.data).map(k => {
        if (infoCollection.data[k].customerId !== customerId && (infoCollection.data[k].RISinsuranceTaker === customerId || infoCollection.data[k].RENinsuranceTaker === customerId)) {
            let childOfferQueryParameters = offerProps.offerQueryParameters[k]
            let childActiveOffers = Object.keys(childOfferQueryParameters).filter(oqp => childOfferQueryParameters[oqp] === true)
            if (childActiveOffers.length > 0) {
                childSum += calculateTotalMonthlyPayment(offerProps, infoCollection, k)
            }
        }
    })

    return sum + childSum
}


export const insuranceTakerHasId = (insuranceTakers, insuranceTakerId) => {
    let hasId = false
    if (insuranceTakers && insuranceTakers.insuranceTakers && insuranceTakers.insuranceTakers[insuranceTakerId]) {
        if (
            insuranceTakers.insuranceTakers[insuranceTakerId].idNumber
            && insuranceTakers.insuranceTakers[insuranceTakerId].idNumber !== ""
            && insuranceTakers.insuranceTakers[insuranceTakerId].idNumber !== "0"
            && insuranceTakers.insuranceTakers[insuranceTakerId].issuer !== ""
            && insuranceTakers.insuranceTakers[insuranceTakerId].validUntil !== ""
            && insuranceTakers.insuranceTakers[insuranceTakerId].idType !== ""
            && insuranceTakers.insuranceTakers[insuranceTakerId].images.length > 0
        ) {
            hasId = true
        }
    }
    return hasId
}


export const insuranceTakerWillUseExistingId = (insuranceTakers, insuranceTakerId) => {
    let useExistingPhotoId = false
    if (insuranceTakers && insuranceTakers.insuranceTakers && insuranceTakers.insuranceTakers[insuranceTakerId]) {
        if (insuranceTakers.insuranceTakers[insuranceTakerId].useExistingPhotoId) {
            useExistingPhotoId = true
        }
    }
    return useExistingPhotoId
}

export const allInsuranceTakersHaveId = (insuranceTakers, signers = []) => {
    let confirms = []
    Object.keys(insuranceTakers.insuranceTakers).map(kennitala => {
        if (signers.length > 0) {
            if (signers.includes(kennitala)) {
                confirms.push(insuranceTakerHasId(insuranceTakers, kennitala))
            } else {
                confirms.push(true)
            }
        } else {
            confirms.push(insuranceTakerHasId(insuranceTakers, kennitala))
        }
    })
    return confirms.every((val) => val === true)
}

export const excludeGuardiansFromSigners = (signers, infoCollection, offerQueryParameters) => {
    let actualSigners = []
    for (let signerId of signers) {
        for (let customerId of Object.keys(offerQueryParameters)) {
            for (let offerType of Object.keys(offerQueryParameters[customerId]).filter((off) => offerQueryParameters[customerId][off] === true)) {
                let _offerType = offerType
                if (offerType === "FOR") {
                    _offerType = "REN"
                }
                if (infoCollection.data[customerId][`${_offerType}insuranceTaker`] === signerId) {
                    actualSigners.push(signerId)
                }
            }
        }
    }
    return actualSigners
}


export const allInsuranceTakersHaveIdOrUseExisting = (insuranceTakers, signerIds = []) => {
    let confirms = []
    Object.keys(insuranceTakers.insuranceTakers).map(kennitala => {
        if (signerIds.length > 0) {
            if (signerIds.includes(kennitala)) {
                confirms.push(insuranceTakerHasId(insuranceTakers, kennitala) || insuranceTakerWillUseExistingId(insuranceTakers, kennitala))
            }
        } else {
            confirms.push(insuranceTakerHasId(insuranceTakers, kennitala) || insuranceTakerWillUseExistingId(insuranceTakers, kennitala))
        }
    });
    return confirms.every((val) => val === true)
}

export const isSignerOnlyGuardian = (infoCollection, offerQueryParameters, signerId) => {
    let actualSigners = []
    for (let customerId of Object.keys(offerQueryParameters)) {
        for (let offerType of Object.keys(offerQueryParameters[customerId]).filter((off) => offerQueryParameters[customerId][off] === true)) {
            let _offerType = offerType
            if (offerType === "FOR") {
                _offerType = "REN"
                if (infoCollection.data[customerId][`${_offerType}insuranceTaker`] !== signerId) {
                    actualSigners.push(true)
                } else {
                    actualSigners.push(false)
                }
            }
       }
    }
    return actualSigners.length > 0 && actualSigners.every((val) => val === true);
}

export const isCustomerRisOnly = (props) => {
    let customerId = props.customerId;
    let theProps = props.props;

    let confirms = []
    for (let offerType of Object.keys(theProps.offerQueryParameters[customerId]).filter((off) => theProps.offerQueryParameters[customerId][off] === true)) {
        if (offerType == "RIS") { // RIS insurers do not need ID
            confirms.push(true);
        } else {
            confirms.push(false);
        }
    }
    return confirms.every((val) => val === true);
}


export const allCustomersRisOnly = (props) => {

    let confirms = []

    for (let customerId of Object.keys(props.offerQueryParameters)) {
        for (let offerType of Object.keys(props.offerQueryParameters[customerId]).filter((off) => props.offerQueryParameters[customerId][off] === true)) {
            if (offerType == "RIS") { // RIS insurers do not need ID
                confirms.push(true);
            } else {
                confirms.push(false);
            }
        }
    }
    return confirms.every((val) => val === true);
}


export const shouldDisplayIdentificationAlert = (insuranceTakers, signers, customerId) => {
    if ((allInsuranceTakersHaveIdOrUseExisting(insuranceTakers, signers) && signers.includes(customerId) && insuranceTakerHasId(insuranceTakers, customerId))) {
        return false;
    }
    else {
        return true;
    }
}

export const insuranceTakerHasTin = (insuranceTakers, insuranceTakerId) => {
    let hasId = false
    if (insuranceTakers && insuranceTakers.insuranceTakers && insuranceTakers.insuranceTakers[insuranceTakerId]) {
        if (insuranceTakers.insuranceTakers[insuranceTakerId].connectionUSA) {
            hasId = insuranceTakers.insuranceTakers[insuranceTakerId].tinOrSsn && insuranceTakers.insuranceTakers[insuranceTakerId].tinOrSsn !== ""
        } else {
            hasId = true
        }
    }
    return hasId
}

export const allInsuranceTakersHaveTin = (insuranceTakers, signers = []) => {

    let confirms = []
    Object.keys(insuranceTakers.insuranceTakers).map(kennitala => {
        if (signers.length > 0) {
            if (signers.includes(kennitala)) {
                confirms.push(insuranceTakerHasTin(insuranceTakers, kennitala))
            } else {
                confirms.push(true)
            }
        } else {
            confirms.push(insuranceTakerHasTin(insuranceTakers, kennitala))
        }
    })
    return confirms.every((val) => val === true)
}

/**
 * @returns {string[]}
 */    
export const getPortfolios = (props) => {
    let { customerId,infoCollection,offers } = props;
    if (customerId == null && offers.offers && Object.keys(offers.offers).length > 0 ) {
        // for simplification we just take the first kennitala
        // that has an offer
        customerId = Object.keys(offers.offers)[0];
    }
    if (customerId == null) {
        return [];
    }
    const keys =  Object.keys(offers.offers[customerId]);
    let portfolios = [];
    for (const key of keys) {
        let _realKey = ['FOR','REND','FORD'].includes(key) ? 'REN' : key;   
        portfolios.push(infoCollection[_realKey+"Portfolio"])
    }
    return  [...new Set(portfolios)];
}



/**
 * @returns {boolean}
 */    
export const usaAandKomfortDynamik = (props) => {
    const portfolios = getPortfolios(props);
    const { insuranceTakers }= props; 
    
    if (portfolios.indexOf('komfortdynamik') === -1) {
        return false;
    }

    for (let taker of Object.values(insuranceTakers.insuranceTakers)) {
        if (taker.connectionUSA) {
            return true; 
        }
    }
    return false;
}


export const ssnIsUSABorn = (ssn, props) => {
    if (props.nationalRegistry) {
        for (const lookup of props.nationalRegistry.history) {
            if (lookup.OrgId === ssn) {
                return lookup.BirthplaceCountryId === 'US';
            }
        }
    }
    return false;
}